'use client';

import { PageView } from '@repo/ui/components/page-view';

import { ErrorHandled } from '~/components/error-handled';
import { NextErrorProps } from '~/types/next-error-props';

const ErrorHandledPage = (props: NextErrorProps) => (
  <PageView>
    <ErrorHandled {...props} />
  </PageView>
);

export default ErrorHandledPage;
